


































































import {Component, Vue} from "vue-property-decorator";
import Company from "@/model/company";
import companyApi from "@/api/companyApi";
@Component({
  name: "PartnerSearch",
})
export default class PartnerSearch extends Vue {
  public isShow = false;
  public companyList: Company[] = null;
  public companyName = "";

  public show() {
    this.companyName = "";
    this.companyList = null;
    this.isShow = true;
  }

  public async doSearch() {
    if(this.companyName.trim() === "") {
      this.companyList = [];
      return;
    }

    const result = await companyApi.list({
      name: this.companyName
    });
    this.companyList = result;
  }

  public insertCompanyId(id) {
    this.$emit('insertCompanyId', id)
    this.isShow = false;
  }
}
